import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from "react";
import { DataTable, createCommandMenu } from "@teselagen/ui";
import { get } from "lodash-es";
import CutsiteFilter from "../../CutsiteFilter";
import { Button, ButtonGroup } from "@blueprintjs/core";
import { connectToEditor } from "../../withEditorProps";
import { compose } from "recompose";
import selectors from "../../selectors";
import _commands from "../../commands";
import { userDefinedHandlersAndOpts } from "../../Editor/userDefinedHandlersAndOpts";
import { pick } from "lodash-es";
import SingleEnzymeCutsiteInfo from "./SingleEnzymeCutsiteInfo";
import { withRestrictionEnzymes } from "../../CutsiteFilter/withRestrictionEnzymes";
import { cutsitesSubmenu } from "../../MenuBar/viewSubmenu";
import { getVisFilter } from "./GenericAnnotationProperties";
const schema = {
  fields: [
    { path: "name", type: "string" },
    { path: "numberOfCuts", type: "number" },
    { path: "groups", type: "string" }
  ]
};
const defaultValues = { order: ["numberOfCuts"] };
const CutsiteProperties = (props) => {
  const commands = _commands({ props });
  const {
    allRestrictionEnzymes,
    allCutsites,
    annotationVisibilityShow,
    createNewDigest,
    dispatch,
    editorName,
    filteredCutsites,
    selectedAnnotationId
  } = props;
  const SubComponent = useCallback(
    (row) => /* @__PURE__ */ jsx(
      SingleEnzymeCutsiteInfo,
      {
        allRestrictionEnzymes,
        allCutsites,
        filteredCutsites,
        editorName,
        dispatch,
        selectedAnnotationId,
        cutsiteGroup: row.original.cutsiteGroup,
        enzyme: row.original.enzyme
      }
    ),
    [
      allCutsites,
      allRestrictionEnzymes,
      dispatch,
      editorName,
      filteredCutsites,
      selectedAnnotationId
    ]
  );
  const onChangeHook = useCallback(() => {
    annotationVisibilityShow("cutsites");
  }, [annotationVisibilityShow]);
  const { cutsitesByName, cutsitesById } = filteredCutsites;
  const cutsitesToUse = useMemo(
    () => Object.values(cutsitesByName || {}).map((cutsiteGroup) => {
      const name = cutsiteGroup[0].restrictionEnzyme.name;
      let groups = "";
      const exisitingEnzymeGroups = window.getExistingEnzymeGroups();
      Object.keys(exisitingEnzymeGroups).forEach((key) => {
        if (exisitingEnzymeGroups[key].includes(name)) groups += key;
        groups += " ";
      });
      return {
        cutsiteGroup,
        id: name,
        name,
        numberOfCuts: cutsiteGroup.length,
        enzyme: cutsiteGroup[0].restrictionEnzyme,
        groups
      };
    }),
    [cutsitesByName]
  );
  const selectedIds = useMemo(
    () => get(cutsitesById[selectedAnnotationId], "restrictionEnzyme.name"),
    [cutsitesById, selectedAnnotationId]
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          marginBottom: 10,
          paddingTop: 3,
          display: "flex",
          // flexWrap: 'wrap',
          width: "100%",
          // justifyContent: "space-between",
          alignItems: "center"
        },
        children: [
          getVisFilter(
            createCommandMenu(cutsitesSubmenu, commands, {
              useTicks: true
            })
          ),
          /* @__PURE__ */ jsx(ButtonGroup, { children: /* @__PURE__ */ jsx(
            Button,
            {
              intent: "success",
              "data-tip": "Virtual Digest",
              icon: "cut",
              style: { marginLeft: 15, flexGrow: -1 },
              onClick: () => {
                createNewDigest();
              }
            }
          ) }),
          /* @__PURE__ */ jsx(
            CutsiteFilter,
            {
              ...pick(props, userDefinedHandlersAndOpts),
              style: { marginLeft: "auto", marginRight: 3 },
              editorName,
              manageEnzymesToLeft: true,
              onChangeHook
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      DataTable,
      {
        selectedIds,
        compact: true,
        noSelect: true,
        noHeader: true,
        noFooter: true,
        withExpandAndCollapseAllButton: true,
        noFullscreenButton: true,
        noPadding: true,
        defaults: defaultValues,
        formName: "cutsiteProperties",
        noRouter: true,
        withSearch: false,
        SubComponent,
        isInfinite: true,
        schema,
        entities: cutsitesToUse
      }
    )
  ] });
};
export default compose(
  connectToEditor((editorState, ownProps) => {
    const cutsites = selectors.filteredCutsitesSelector(
      editorState,
      ownProps.additionalEnzymes,
      ownProps.enzymeGroupsOverride
    );
    const allCutsites = selectors.cutsitesSelector(
      editorState,
      ownProps.additionalEnzymes
    );
    return {
      annotationVisibility: editorState.annotationVisibility || {},
      filteredCutsites: cutsites,
      allCutsites,
      cutsites: cutsites.cutsitesArray
    };
  }),
  withRestrictionEnzymes
)(CutsiteProperties);
